import api from './api';

// uara活动列表展示
export const getUaraList = params => {
  return api('post', '/v1/management/uara/list', params);
};

// 活动类型列表
export const getUaraTypeList = () => {
  return api('get', '/v1/management/uara/type-list');
};

// 新增活动
export const addUaraList = params => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api('post', '/v1/management/uara/add-activity', params, config);
};

// 删除活动
export const delUaraList = id => {
  return api("delete", `/v1/management/uara/del-activity/${id}`);
};

// 活动详情
export const getItemUaradetail = id => {
  return api("get", `/v1/management/uara/detail/${id}`);
};

// 编辑活动
export const editUaraList = params => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("post", '/v1/management/uara/edit-activity', params, config);
};

// 开放报名
export const openRegistration = params => {
  return api("post", `/v1/management/uara/openRegistration`, params);
};

// 发布活动
export const openUaraList = params => {
  return api("post", '/v1/management/uara/release-activities', params);
};

// 下架活动
export const closeUaraList = params => {
  return api("post", '/v1/management/uara/offline-activities', params);
};

// 导入排行榜
export const toUaraLeaderboard = params => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("post", '/v1/management/uara/uaraLeaderboard', params, config);
};

// 导出uara报名名单
export const exportEnrollmentList = id => {
  return api("get", `/v1/management/uara/exportEnrollmentList/${id}`,
    {},
    {
      responseType: "blob",
    });
};

// 导出uara身份证信息表
export const exampleExportTheIDCardInformationTable = activityId => {
  return api("get", `/v1/management/uara/exampleExportTheIDCardInformationTable/${activityId}`,
    {},
    {
      responseType: "blob",
    });
};

// 上传复试名单
export const upLoadTheReExaminationList = formData => {
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("post", '/v1/management/uara/uploadTheReExaminationList', formData, config);
};

// 榜单名称
export const getLeaderBoardName = () => {
  return api('get', '/v1/management/uara/leaderBoardName');
};

// 查询活动二维码
export const searchUaraItemQrcode = activityId => {
  return api("get", `/v1/management/uara/qrcode/${activityId}`);
};

